import React, { useEffect } from 'react';
const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
        dateObject = new Date(date.replace(/-/g, "/"));
    }
    formattedDate = dateObject.toLocaleDateString(navigator.language, options);
    formattedDate = formattedDate.replace(/ /g, '-').replace(/,/g, '');
    return formattedDate;
};
function getMonthDays(year, month) {
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
}
function GraphDataTable({ type, simObj, setSimObj }) {
    let CostQualityData;
    let FailureData;
    switch (type) {
        case "monthly":

            CostQualityData = simObj?.graphdata?.filter((data, index) => {
                if (data.sm === simObj.laststate.statemonth) {
                    return true;
                }
            });
            CostQualityData = (CostQualityData != undefined ? CostQualityData : []).map((data) => {
                return {
                    x: data.sd,
                    y: data.ct,
                    date: getDate(data.cd),
                    cost: Math.round(data.ct),
                    costOfInternalFailures: Math.round(data.ci),
                    costOfExternalFailures: data.cce,
                    costOfPreventiveInvestment: data.cp,
                    costOfAppraisal: data.ca,
                    costOfotherInvestment: data.crh,
                    revenue: data.rv,
                }
            });
              FailureData = simObj?.graphdata?.filter((data, index) => {
                if (data?.sm === simObj?.laststate?.statemonth) {
                  return true;
                }
              });
              FailureData = (FailureData != undefined ? FailureData : []).map((data) => {
                return {
                  x: data.sd,
                  y: data.fr,
                  date: getDate(data.cd),
                  externalFailureRate: data.ef,
                  internalFailureRate: data.if
    
                }
              });
            break;
        case "quarterly":
            CostQualityData = simObj?.graphdata?.filter((data, index) => {
                if (data.sm >= simObj.laststate.statemonth - 2) {
                    return true;
                }
            });
            CostQualityData = (CostQualityData != undefined ? CostQualityData : []).map((data) => {
                return {
                    x: ((data.sm - 1) + (data.sd / getMonthDays(simObj.laststate.stateyear, data.sm))).toFixed(2),
                    y: data.ct,
                    cost: Math.round(data.ct),
                    date: getDate(data.cd),
                    costOfInternalFailures: Math.round(data.ci),
                    costOfExternalFailures: data.cce,
                    costOfPreventiveInvestment: data.cp,
                    costOfAppraisal: data.ca,
                    costOfotherInvestment: data.crh,
                    revenue: data.rv,
                }
            });
              FailureData = simObj?.graphdata?.filter((data, index) => {
                if (data.sm >= simObj?.laststate?.statemonth - 2) {
                  return true;
                }
              });
              FailureData = (FailureData != undefined ? FailureData : []).map((data) => {
                return {
                  x: (data.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data.sm)),
                  y: data.fr,
                  date: getDate(data.cd),
                  externalFailureRate: data.ef,
                  internalFailureRate: data.if
                }
              });
            break;
        case "yearly":
            CostQualityData = simObj?.graphdata;
            CostQualityData = (CostQualityData != undefined ? CostQualityData : []).map((data) => {
                return {
                    x: ((data.sm - 1) + (data.sd / getMonthDays(simObj.laststate.stateyear, data.sm))).toFixed(2),
                    y: data.ct,
                    cost: Math.round(data.ct),
                    date: getDate(data.cd),
                    costOfInternalFailures: Math.round(data.ci),
                    costOfExternalFailures: data.cce,
                    costOfPreventiveInvestment: data.cp,
                    costOfAppraisal: data.ca,
                    costOfotherInvestment: data.crh,
                    revenue: data.rv,
                }
            });
            FailureData = simObj?.graphdata;
            FailureData = (FailureData != undefined ? FailureData : []).map((data) => {
              return {
                x: (data?.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data?.sm)),
                y: data.fr,
                date: getDate(data.cd),
                externalFailureRate: data.ef,
                internalFailureRate: data.if
              }
            });
            break;
        default:
            CostQualityData = [];
            FailureData=[];
            break;
    }


    return (
        <div className="header-container">
            <header class="header main-header"><div class="container"><h1 class="title" aria-hidden="false" tabindex="-1">Quality Management Simulation Graph Data as of  {getDate(simObj?.laststate?.currentRampDate)}</h1></div></header>
            <div className="MainDiv">
                <div className="MainDivChild">
                    <div class="jumbotron text-center bg-sky">
                        <h3 className="headingh3">Revenue/ Cost Of Quality Graph Data</h3>
                    </div>

                    <div className="container">

                        <table id="RevenueGraphData" class="display cell-border">
                            <thead>
                                <tr>
                                    <th>Day</th>
                                    <th>Cost</th>
                                    <th>Internal Failure Cost</th>
                                    <th>External Failure Cost</th>
                                    <th>Preventive Investment</th>
                                    <th>Appraisal Investment</th>
                                    <th>Other Investments</th>
                                    <th>Revenue</th>

                                </tr>
                            </thead>
                            <tbody>
                                {CostQualityData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{data.date}</td>
                                        <td>${data.cost}</td>
                                        <td>${data.costOfInternalFailures}</td>
                                        <td>${data.costOfExternalFailures}</td>
                                        <td>${data.costOfPreventiveInvestment}</td>
                                        <td>${data.costOfAppraisal}</td>
                                        <td>${data.costOfotherInvestment}</td>
                                        <td>${data.revenue}</td>


                                    </tr>
                                ))}
                            </tbody>

                        </table>


                    </div>
                    <p></p>
                    <div className="container">

                        <div class="jumbotron text-center bg-sky">
                            <h3 className="headingh3">Failure Rate Graph Data</h3>
                        </div>
                        <table id="FailureGraphData" class="display cell-border">
                            <thead>
                                <tr>
                                    <th>Day</th>
                                    <th>Internal Failure Rate</th>
                                    <th>External Failure Rate</th>
                                </tr>
                            </thead>
                            <tbody>
                                {FailureData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{data.date}</td>
                                        <td>{data.internalFailureRate}%</td>
                                        <td>{data.externalFailureRate}%</td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
            <footer className="footer">
                <div className="container">

                    <span className="copyright-text">Copyright &#169;2023 </span>
                    <ul className="footer-links">
                        <li className="listitem"><a href="https://www.pearson.com/en-us.html" target='_blank'>Pearson Education</a></li>
                        <li className="listitem"><span>&nbsp;|&nbsp;</span></li>
                        <li className="listitem"><a href="https://loginstatic.pearson.com/html/PearsonPrivacyPolicy.html?" target='_blank'>Privacy Policy</a></li>
                    </ul>
                </div>

            </footer>

        </div>

    );
}

export default GraphDataTable;
